import React from 'react';
import { Box, Typography } from '@mui/material';

interface NoteIdSectionProps {
  noteId: string | undefined;
}

export const NoteIdSection: React.FC<NoteIdSectionProps> = ({ noteId }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="caption"
        sx={{
          color: '#9ca3af',
          fontFamily: 'monospace',
          fontSize: '0.75rem'
        }}
      >
        Note ID: {noteId}
      </Typography>
    </Box>
  );
};
